import type { InspectorApi, InspectorProfile, InspectorTask, PastAttestation } from './types.js';
import { HISTORY, PROFILE, TASKS } from './fixtures.js';

/**
 * In-memory InspectorApi backed by fixtures so the field/lab app is fully interactive
 * offline (PRD §10.4). Async to match the eventual network impl (HttpApi) — screens cannot
 * tell them apart.
 */
export class FixtureApi implements InspectorApi {
  getProfile(): Promise<InspectorProfile> {
    return Promise.resolve(PROFILE);
  }
  getTasks(): Promise<InspectorTask[]> {
    return Promise.resolve(TASKS);
  }
  getHistory(): Promise<PastAttestation[]> {
    return Promise.resolve(HISTORY);
  }
}
